<template>
  <div
    :class="['c-header-search-input', 'js-ignore-click-event', color, size]"
    @click="focus"
  >
    <i class="c-header-search-input__icon icon-search"></i>
    <input
      type="text"
      inputmode="search"
      :class="['c-header-search-input__input', size]"
      :placeholder="placeholder"
      ref="input"
      @focus="focus"
      @input="$emit('search-keyword-input', $event.target.value)"
      @keydown.enter="emitComposedValue"
    />
  </div>
</template>

<script>
export default {
  name: 'ComponentHeaderSearchInput',
  props: {
    color: { type: String, default: 'white' },
    placeholder: { type: String, default: '' },
    value: { type: String, default: '' },
    size: { type: String, default: 'medium' },
  },
  methods: {
    emitComposedValue($event) {
      const value = $event.target.value
      if (!$event.isComposing && value)
        this.$emit('search-input-entered', value)
    },
    focus() {
      this.$emit('search-input-focused')
      this.$refs.input.focus()
    },
  },
}
</script>
<style lang="scss" scoped>
@use '~/scss/generic/variables';

.c-header-search-input {
  padding: 12px 24px;
  border: 1px solid variables.$color-brown;
  border-radius: 6px;
  background-color: #fff;
  display: flex;
  align-items: center;
  cursor: text;

  &.gray {
    background-color: variables.$color-gray;
    border-color: variables.$color-gray;
  }

  &.small {
    border-radius: 4px;
    padding: 12px 20px;
  }

  &__icon {
    font-size: 18px;
    margin-right: 8px;
  }

  &__input {
    border: 0;
    background-color: transparent;
    flex-grow: 1;
    outline: none;

    &::placeholder {
      color: variables.$color-text-gray;
    }

    &.small {
      font-size: 16px;
    }
  }
}
</style>
